import './UserDetails.scss';

import React from 'react';
import moment from 'moment';

import A from 'components/A';
import Thumbnail from 'components/Thumbnail';

import { USER_ROLES_LOOKUP } from 'utils/constants';

export default class UserDetails extends React.Component {
    static propTypes = {
        className: React.PropTypes.string,
        emailAsLink: React.PropTypes.bool,
        infoClassName: React.PropTypes.string,
        user: React.PropTypes.object.isRequired
    };

    render() {
        let { user } = this.props;

        return (
            <div className={`user-details ${this.props.className || ''}`}>
                <header className="user-details__header">
                    <div className="user-modal__thumbnail">
                        <Thumbnail defaultAvatar="users"
                                   thumbnailID={user.thumbnail ? user.thumbnail.id : null} />
                    </div>
                    <div className="user-details__name">
                        {user.firstName} {user.lastName}
                    </div>
                    {/*<div className="modal__buttons">
                     <ModalButton className="user-details__reset-password-button reset-password-button"
                     icon="reset-password"
                     onClick={(event) => { console.log(event.target); }}
                     text="Reset Password" />
                     </div>*/}
                </header>

                <div className={`user-details__info ${this.props.infoClassName || ''}`}>
                    <div className="user-details__email">
                        {this.props.emailAsLink !== false ? (
                            <A href={`mailto:${user.userName}`} target="_blank">{user.userName}</A>
                        ) : user.userName}
                    </div>
                    <div className="user-details__last-accessed modal__description">
                        <span>Last Accessed:</span> {moment(user.lastAccessed).format('MM/DD/YY [at] h:mma')}
                    </div>
                    <div className="user-details__role modal__description">
                        <span>Role:</span> {USER_ROLES_LOOKUP[user.role]}
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/UserDetails/index.js